import type { KnowledgeNodeSchema } from "./knowledgeBase"

/**
 * Knowledge Base (KnowledgeNode) Utilities
 *
 * Helper functions for working with KnowledgeNode data in the agent context.
 */

export interface KnowledgeBaseFolder {
  id: string
  name: string
}

export const knowledgeNodeResponseToKnowledgeBaseFolder = (
  node: KnowledgeNodeSchema
): KnowledgeBaseFolder => ({
  id: node.id,
  name: node.name,
})
